import {
  FUND_INFO, KUSPIT_LEGAL_LINK_LABEL, KUSPIT_LEGAL_NOTICE, KUSPIT_LEGAL_TITLE, KUSPIT_WALLET_NOTICE, PESO_A_PESO_NOTICE, TRAVEL_AGENCY_NOTICE,
  type DisclosureParagraph
} from "@aventuria/client-core/disclosures";
import { useId, useState } from "react";
import { Modal } from "./Modal";

/** One paragraph of legal copy; linked runs open in a new tab. */
export function DisclosureParagraphText({ paragraph }: { paragraph: DisclosureParagraph }) {
  return (
    <p>
      {paragraph.map((run, index) => (typeof run === "string"
        ? <span key={index}>{run}</span>
        : <a key={index} href={run.href} target="_blank" rel="noreferrer">{run.text}</a>))}
    </p>
  );
}

/** Footer of the trip catalogue: Aventuria is a travel agency; Kuspit and Peso a Peso provide the financial services. */
export function TravelAgencyNotice() {
  return <p className="wallet-legal legal-notice">{TRAVEL_AGENCY_NOTICE}</p>;
}

/** Wallet footer: Kuspit provides the investment service. The link opens the full legal notice. */
export function KuspitNotice({ className = "wallet-legal legal-notice" }: { className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <p className={className}>
        {KUSPIT_WALLET_NOTICE}{" "}
        <button type="button" className="legal-link" onClick={() => setOpen(true)}>{KUSPIT_LEGAL_LINK_LABEL}</button>
      </p>
      <Modal open={open} onOpenChange={setOpen} label={KUSPIT_LEGAL_TITLE}>
        <div className="dialog-content">
          <span className="page-eyebrow">Wallet</span>
          <h2>{KUSPIT_LEGAL_TITLE}</h2>
          <div className="dialog-form conditions legal-full" translate="no">
            {KUSPIT_LEGAL_NOTICE.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            <button type="button" className="secondary-button full" onClick={() => setOpen(false)}>Entendido</button>
          </div>
        </div>
      </Modal>
    </>
  );
}

/** Credit footer: who grants the loans; "Ver más" reveals the rest of the notice in place. */
export function PesoAPesoNotice() {
  const [expanded, setExpanded] = useState(false);
  const moreId = useId();
  return (
    <div className="wallet-legal legal-notice credit-notice" translate="no">
      {PESO_A_PESO_NOTICE.summary.map((paragraph, index) => (
        <p key={paragraph}>
          {paragraph}
          {index === PESO_A_PESO_NOTICE.summary.length - 1 && !expanded && (
            <>{" "}<button type="button" className="legal-link" aria-expanded={false} aria-controls={moreId} onClick={() => setExpanded(true)}>Ver más</button></>
          )}
        </p>
      ))}
      <div id={moreId} hidden={!expanded}>
        {PESO_A_PESO_NOTICE.more.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        <p><button type="button" className="legal-link" aria-expanded={expanded} aria-controls={moreId} onClick={() => setExpanded(false)}>Ver menos</button></p>
      </div>
    </div>
  );
}

/** "Cómo se invierte tu dinero": the fund, with the objective, liquidity, fee and documents behind "Ver más". */
export function FundInfo() {
  const [expanded, setExpanded] = useState(false);
  const moreId = useId();
  return (
    <div className="fund-info" translate="no">
      {FUND_INFO.summary.map((paragraph, index) => <DisclosureParagraphText key={index} paragraph={paragraph} />)}
      <div id={moreId} hidden={!expanded} className="fund-info-more">
        {FUND_INFO.more.map((paragraph, index) => <DisclosureParagraphText key={index} paragraph={paragraph} />)}
      </div>
      <button type="button" className="legal-link" aria-expanded={expanded} aria-controls={moreId} onClick={() => setExpanded(!expanded)}>
        {expanded ? "Ver menos" : "Ver más"}
      </button>
    </div>
  );
}
